"use client";

/**
 * @contract
 *   Назначение: Кнопка копирования текста в буфер обмена
 *   Автор:      AI Agent (Фаза A')
 *   Дата:       2026-03-17
 */

import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

interface CopyButtonProps {
  text: string;
  className?: string;
}

export function CopyButton({ text, className = "" }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`inline-flex items-center justify-center w-5 h-5 rounded-sm hover:bg-white/10 transition-colors ${className}`}
      title="Скопировать"
      aria-label="Скопировать"
    >
      {copied ? (
        <Check className="w-3 h-3 text-green-400" />
      ) : (
        <Copy className="w-3 h-3 text-white/30 hover:text-white/60" />
      )}
    </button>
  );
}
